import { Injectable, Type } from '@angular/core';
import { ImageTextCellComponent } from '../image-text-cell/image-text-cell.component';
import { BookmarkCellComponent } from '../bookmark-cell/bookmark-cell.component';

export interface CellRendererConfig {
  component: Type<any>;
  params?: any;
}

@Injectable()
export class GridCellRendererService {

  constructor() { }

  items = new Map<string, Type<any> | CellRendererConfig>([
    ["name", 
      { component: ImageTextCellComponent }
    ],
    ["favorite", BookmarkCellComponent],
  ])

  categories = new Map<string, Type<any> | CellRendererConfig>([
    ["name", 
      { component: ImageTextCellComponent, 
        params: { showImage: false } }
    ]
  ])
}
